export const tableColors = {
  primaryColor: "#00aa1c",
  secondarColor: "#04324d",
  gradiantColor: `linear-gradient(
    0deg,
    rgba(237, 243, 252, 1) 20%,
    rgba(246, 228, 255, 1) 100%
  )`,
  light: "#FFFFFF",
  dark: "#000000",
  bodyRowColor: "#ffffffff",
  headRowColor: "#f1f1f1f5",
  backGroundColor: "#ffffffea",
};
